export const IMAX_NEXT_RELEASES = 'IMAX_NEXT_RELEASES';
